import { createFileRoute, redirect } from '@tanstack/react-router';
import { type z } from 'zod';

import { automationDetailSearchSchema } from '@apps/web/components/automations/agent_configuration_search';

export function handleAutomationBeforeLoad({
    params,
    search,
}: {
    readonly params: { readonly automationId: string };
    readonly search: z.infer<typeof automationDetailSearchSchema>;
}): void {
    throw redirect({
        to: '/routines/$routineId',
        params: { routineId: params.automationId },
        search,
        replace: true,
    });
}

export const Route = createFileRoute('/_app/(main)/automations/$automationId')({
    validateSearch: automationDetailSearchSchema,
    beforeLoad: handleAutomationBeforeLoad,
});
